export default {
  title: {
    id: 'bo_sellers-orders-drawers-order_recap-new_modal_title',
    defaultMessage: 'Order {orderId}',
  },
  tabsBar: {
    id: 'bo_sellers-orders-tabs_bar',
    defaultMessage: 'Orders tabs',
  },
  orderDetailsTab: {
    id: 'bo_sellers-orders-drawers-order_details_tab_label',
    defaultMessage: 'Order details',
  },
  financialDetailsTab: {
    id: 'bo_sellers-orders-drawers-financial_details_tab_label',
    defaultMessage: 'Financial details',
  },
} as const
